import React from 'react'
import Paragraph from './Paragraph'
import Button from './Button'

const StartVerify = () => {
  return (
    <div className='start-verify-wrap'>
        <Paragraph variant="lead" content="Why Get Business Verified on FinditZ?" />
        <Paragraph content="Becoming a verified business on FinditZ will help your company stand out, build trust, and increase visibility." />
        <Button variant="btn-primary" label="Start Verification" />
    </div>
  )
}

export default StartVerify